import "./scss/pages/news.scss";
import "../../node_modules/@fortawesome/fontawesome-free/css/brands.css";
import "../../node_modules/@fortawesome/fontawesome-free/css/fontawesome.css";
import "../../node_modules/@fortawesome/fontawesome-free/css/solid.css";
import { createDropdown } from "./scripts/uiHelpers";

createDropdown("#splash-more");
